import React, { FC } from 'react';
import { Icons } from '@monorepo/icons';
import { Flex, TextComponent } from '@monorepo/react-components';
import { IconsNames } from '@monorepo/types';

import styles from './benefit-card.module.scss';

interface Props {
  benefit: {
    icon: IconsNames;
    title: string;
  };
  index: number;
  isMarked?: boolean;
}

const BenefitCard: FC<Props> = ({ benefit, isMarked }) => {
  return (
    <Flex
      className={`${styles.benefitCard} ${isMarked ? styles.markedCard : ''}`}
    >
      <Icons iconName={benefit.icon} />
      <TextComponent level={4} weight={600}>
        {benefit.title}
      </TextComponent>
    </Flex>
  );
};

export default BenefitCard;
